import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Button,
  Flex,
  IconButton,
  Input,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Portal,
  Spacer,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  useDisclosure,
} from '@chakra-ui/react';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { FaRegEdit } from 'react-icons/fa';
import { RiDeleteBinLine } from 'react-icons/ri';
import AddNewVariationButton from './AddNewVariationButton';
import EditVariationModal from './EditVariationModal';
import DeleteVariationModal from './DeleteVariationModal';
import { ChevronRightIcon } from '@chakra-ui/icons';

type FormDataType = {
  documentid: number;
  name: string;
  description: string;
  variationid: number;
  fields: [];
  file: {};
};

function PayerFormsVariations({
  document,
  setTabIndex,
}: {
  document: any;
  setTabIndex: any;
}) {
  const [count, setCount] = useState(0);
  const [variationsData, setVariationsData] = useState<FormDataType[]>([]);
  const [editVariationData, setEditVariationData] = useState({});
  const [deleteVariationID, setDeleteVariationID] = useState<number | null>(
    null
  );
  const {
    isOpen: isOpenEdit,
    onOpen: onOpenEdit,
    onClose: onCloseEdit,
  } = useDisclosure();
  const {
    isOpen: isOpenDelete,
    onOpen: onOpenDelete,
    onClose: onCloseDelete,
  } = useDisclosure();

  useEffect(() => {
    const baseurl = process.env.REACT_APP_PAYER_FORM_BASE_URL as string;
    const tokenUrl = process.env.REACT_APP_TOKEN_URL_PAYER_FORM as string;
    // Function to fetch the token and then the forms
    const fetchForms = async () => {
      try {
        const tokenResponse = await axios.get(tokenUrl);
        if (tokenResponse.data.success) {
          const formsResponse = await axios.get(
            baseurl +
              '/App/api/get_document_variations?documentid=' +
              document.documentid,
            {
              headers: {
                Pragma: 'no-cache',
                Authorization: 'Bearer ' + tokenResponse.data.token,
              },
            }
          );
          if (formsResponse.data.success) {
            setVariationsData(formsResponse.data.variations);
          } else {
            throw new Error('Failed to fetch forms');
          }
        } else {
          throw new Error('Failed to retrieve auth token');
        }
      } catch (error) {
        console.error('Error fetching forms:', error);
      }
    };

    fetchForms();
  }, [count]);

  return (
    <>
      <Box display=" flex" flexDirection="column" mt="10px">
        <Flex
          display="flex"
          justifyContent="flex-end"
          paddingBottom=".5rem"
          ml="20px"
          fontSize={20}
        >
          <Breadcrumb
            spacing="8px"
            separator={<ChevronRightIcon color="gray.500" />}
          >
            <BreadcrumbItem>
              <BreadcrumbLink
                href="#"
                onClick={() => {
                  setTabIndex(0);
                }}
              >
                Payer Forms
              </BreadcrumbLink>
            </BreadcrumbItem>

            <BreadcrumbItem isCurrentPage>
              <BreadcrumbLink href="#">{document.name}</BreadcrumbLink>
            </BreadcrumbItem>
          </Breadcrumb>
          <Spacer />
          <Flex flexDirection="column" float="right">
            <AddNewVariationButton
              documentID={document.documentid}
              count={count}
              setCount={setCount}
            />

            {/* <Input
              marginTop="15px"
              width="auto"
              type="text"
              placeholder="Search Form..."
              // onChange={filterData}
              marginRight="0.5rem"
            /> */}
          </Flex>
        </Flex>
        <TableContainer borderRadius="5px" borderTopColor="black">
          <Table
            variant="striped"
            colorScheme="blackAlpha"
            size="sm"
            overflow="Auto"
          >
            <Thead bgColor="#002677">
              <Tr>
                <Th color="white">NAME</Th>
                <Th color="white">DESCRIPTION</Th>
                <Th color="white" isNumeric>
                  ACTIONS
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              <>
                {variationsData
                  ? variationsData.map(data => (
                      <Tr key={data.variationid}>
                        <Td color="blue">
                          <Link
                            onClick={() => {
                              setEditVariationData(data);
                              onOpenEdit();
                            }}
                          >
                            {data.name}
                          </Link>
                        </Td>
                        <Td>{data.description}</Td>
                        <Td pt="0" pb="0" mt="0" mb="0" isNumeric pr="30px">
                          <Menu>
                            <MenuButton
                              as={IconButton}
                              icon={<BsThreeDotsVertical />}
                              size="xs"
                              aria-label="Options"
                              variant="outline"
                            />
                            <Portal>
                              <MenuList>
                                <MenuItem
                                  icon={<FaRegEdit />}
                                  onClick={() => {
                                    setEditVariationData(data);
                                    onOpenEdit();
                                  }}
                                >
                                  Edit
                                </MenuItem>
                                <MenuItem
                                  icon={<RiDeleteBinLine />}
                                  onClick={() => {
                                    setDeleteVariationID(data.variationid);
                                    onOpenDelete();
                                  }}
                                >
                                  Delete
                                </MenuItem>
                              </MenuList>
                            </Portal>
                          </Menu>
                        </Td>
                      </Tr>
                    ))
                  : ''}
              </>
            </Tbody>
          </Table>
        </TableContainer>
        <Flex flexDirection="column" float="right" mt="20px">
          <Button
            h="35px"
            w="fit-content"
            fontSize="15px"
            bg="#002677"
            textColor="white"
            mr="0.5rem"
            float="right"
            ml="auto"
            onClick={() => {
              setTabIndex(0);
            }}
          >
            Close
          </Button>
        </Flex>
      </Box>
      <DeleteVariationModal
        isOpen={isOpenDelete}
        onClose={onCloseDelete}
        variationID={deleteVariationID}
        count={count}
        setCount={setCount}
      />
      <EditVariationModal
        isOpen={isOpenEdit}
        onClose={onCloseEdit}
        variationData={editVariationData}
        setVariationData={setEditVariationData}
        documentID={document.documentid}
        count={count}
        setCount={setCount}
      />
    </>
  );
}

export default PayerFormsVariations;
